<div id="hdw-map" #mapViewDiv style="height: 100%; width: 100%">
  <hdw-loader [canShow]="canShowLoader"></hdw-loader>
</div>
